import { Component } from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';
import DOM from 'react-dom-factories';

export default class DateTimePickerTime extends Component {
  static propTypes = {
    timeFormat: PropTypes.string,
    selectedDate: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    viewDate: PropTypes.oneOfType([ PropTypes.string, PropTypes.object ]),
    dateFormat: PropTypes.string,
    value: PropTypes.string,
    minDate: PropTypes.string,
    maxDate: PropTypes.string,
    setTime: PropTypes.func,
    showView: PropTypes.func,
    handleClickOutside: PropTypes.func,
  };

  constructor (props) {
    super(props);

    this.state = this.calculateState(props);
    this.padValues = {
      hours: 1,
      minutes: 2,
      seconds: 2,
      milliseconds: 3,
    };

    this.isDisabledIncrease = this.isDisabledIncrease.bind(this);
    this.isDisabledDecrease = this.isDisabledDecrease.bind(this);
  }

  componentWillMount () {
    let me = this;
    me.timeConstraints = {
      hours: {
        min: 0,
        max: 23,
        step: 1,
      },
      minutes: {
        min: 0,
        max: 59,
        step: 1,
      },
      seconds: {
        min: 0,
        max: 59,
        step: 1,
      },
      milliseconds: {
        min: 0,
        max: 999,
        step: 1,
      },
    };
    [ 'hours', 'minutes', 'seconds', 'milliseconds' ].forEach(function (type) {
      assign(me.timeConstraints[ type ], me.props.timeConstraints[ type ]);
    });
    this.setState(this.calculateState(this.props));
  }

  componentWillReceiveProps (props) {
    this.setState(this.calculateState(props));
  }

  calculateState (props) {
    let date = props.selectedDate || props.viewDate;
    let format = props.timeFormat;
    let counters = [];

    if (format.toLowerCase().indexOf('h') !== -1) {
      counters.push('hours');
      if (format.indexOf('m') !== -1) {
        counters.push('minutes');
        if (format.indexOf('s') !== -1) {
          counters.push('seconds');
        }
      }
    }

    let daypart = false;
    if (this.state !== null && this.props.timeFormat.toLowerCase().indexOf(' a') !== -1) {
      if (this.props.timeFormat.indexOf(' A') !== -1) {
        daypart = this.state.hours >= 12 ? 'PM' : 'AM';
      } else {
        daypart = this.state.hours >= 12 ? 'pm' : 'am';
      }
    }

    return {
      hours: date.format('H'),
      minutes: date.format('mm'),
      seconds: date.format('ss'),
      milliseconds: date.format('SSS'),
      daypart: daypart,
      counters: counters,
    };
  }

  renderCounter (type) {
    if (type !== 'daypart') {
      let value = this.state[ type ];
      let currentDateTime = new Date(this.props.value);
      let isDisabledIncrease = this.isDisabledIncrease(type, currentDateTime);
      let isDisabledDecrease = this.isDisabledDecrease(type, currentDateTime);

      if (type === 'hours' && this.props.timeFormat.toLowerCase().indexOf(' a') !== -1) {
        value = (value - 1) % 12 + 1;

        if (value === 0) {
          value = 12;
        }
      }

      return DOM.div({ key: type, className: 'date-time-picker-counter' }, [
        DOM.span(
          {
            key: 'up',
            className: isDisabledIncrease ?
              'date-time-picker-btn date-time-picker-disabled fa fa-chevron-up' :
              'date-time-picker-btn fa fa-chevron-up',
            onMouseDown: isDisabledIncrease ? null : this.onStartClicking('increase', type),
          },
          ''
        ),
        DOM.div({ key: 'c', className: 'date-time-picker-count' }, value),
        DOM.span(
          {
            key: 'do',
            className: isDisabledDecrease ?
              'date-time-picker-btn date-time-picker-disabled fa fa-chevron-down' :
              'date-time-picker-btn fa fa-chevron-down',
            onMouseDown: isDisabledDecrease ? null : this.onStartClicking('decrease', type),
          },
          ''
        ),
      ]);
    }
    return '';
  }

  isSameDate (date, pDate) {
    return (
      date.getFullYear() === pDate.getFullYear() &&
      date.getMonth() === pDate.getMonth() &&
      date.getDate() === pDate.getDate()
    );
  }

  isDisabledIncrease (type, currentDate) {
    let disabled = false;
    let currentDateHours = currentDate.getHours();
    let currentDateMin = currentDate.getMinutes();
    let currentDateSec = currentDate.getSeconds();

    if (this.props.minDate) {
      let minDate = new Date(this.props.minDate);

      if (this.isSameDate(minDate, currentDate)) {
        if (currentDateHours === 23) {
          if (type === 'hours') {
            return true;
          }
        }

        if (currentDateHours === minDate.getHours()) {
          if (currentDateMin === 59) {
            if (type === 'minutes') {
              return true;
            }
          }
          if (currentDateMin === minDate.getMinutes()) {
            if (currentDateSec === 59) {
              if (type === 'seconds') {
                return true;
              }
            }
          }
        }
      }
    }

    if (this.props.maxDate) {
      let maxDate = new Date(this.props.maxDate);
      if (!this.isSameDate(maxDate, currentDate)) {
        return false;
      }

      let maxDateHours = maxDate.getHours();
      let maxDateMin = maxDate.getMinutes();
      let maxDateSec = maxDate.getSeconds();

      switch (type) {
        case 'hours':
          if (currentDateHours === 23) {
            disabled = true;
          }

          if (currentDateHours >= maxDateHours) {
            disabled = true;
          }
          if (currentDateHours === maxDateHours - 1) {
            if (currentDateMin > maxDateMin) {
              disabled = true;
            }
            if (currentDateMin >= maxDateMin && currentDateSec > maxDateSec) {
              disabled = true;
            }
          }
          break;
        case 'minutes':
          if (currentDateHours >= maxDateHours) {
            if (currentDateMin >= maxDateMin) {
              disabled = true;
            }
          }

          if (currentDateHours === maxDateHours) {
            if (currentDateMin === maxDateMin - 1) {
              if (currentDateMin === 59) {
                disabled = true;
              }

              if (currentDateSec > maxDateSec) {
                disabled = true;
              }
            }
          }
          break;
        case 'seconds':
          if (currentDateHours >= maxDateHours) {
            if (currentDateMin >= maxDateMin) {
              if (currentDateSec >= maxDateSec) {
                disabled = true;
              }
            }
          }
          break;
        default:
          break;
      }
    }

    return disabled;
  }

  isDisabledDecrease (type, currentDate) {
    let disabled = false;
    let currentDateHours = currentDate.getHours();
    let currentDateMin = currentDate.getMinutes();
    let currentDateSec = currentDate.getSeconds();

    if (this.props.maxDate) {
      let maxDate = new Date(this.props.maxDate);

      if (this.isSameDate(maxDate, currentDate)) {
        if (currentDateHours === 0) {
          if (type === 'hours') {
            return true;
          }
        }

        if (currentDateHours === maxDate.getHours()) {
          if (currentDateMin === 0) {
            if (type === 'minutes') {
              return true;
            }
          }
          if (currentDateMin === maxDate.getMinutes()) {
            if (currentDateSec === 0) {
              if (type === 'seconds') {
                return true;
              }
            }
          }
        }
      }
    }

    if (this.props.minDate) {
      let minDate = new Date(this.props.minDate);

      if (!this.isSameDate(minDate, currentDate)) {
        return false;
      }
      let minDateHours = minDate.getHours();
      let minDateMin = minDate.getMinutes();
      let minDateSec = minDate.getSeconds();

      switch (type) {
        case 'hours':
          if (currentDateHours === 0) {
            disabled = true;
          }

          if (currentDateHours <= minDateHours) {
            disabled = true;
          }

          if (currentDateHours === minDateHours + 1) {
            if (currentDateMin < minDateMin) {
              disabled = true;
            }
            if (currentDateMin <= minDateMin && currentDateSec < minDateSec) {
              disabled = true;
            }
          }
          break;
        case 'minutes':
          if (currentDateHours <= minDateHours) {
            if (currentDateMin <= minDateMin) {
              disabled = true;
            }
          }

          if (currentDateHours === minDateHours) {
            if (currentDateMin === minDateMin + 1) {
              if (currentDateMin === 0) {
                disabled = true;
              }

              if (currentDateSec < minDateSec) {
                disabled = true;
              }
            }
          }
          break;
        case 'seconds':
          if (currentDateHours <= minDateHours) {
            if (currentDateMin <= minDateMin) {
              if (currentDateSec <= minDateSec) {
                disabled = true;
              }
            }
          }
          break;
        default:
          break;
      }
    }

    return disabled;
  }

  renderDayPart () {
    return DOM.div({ key: 'dayPart', className: 'date-time-picker-counter' }, [
      DOM.span(
        {
          key: 'up',
          className: 'date-time-picker-btn fa fa-chevron-up',
          onClick: this.onStartClicking('toggleDayPart', 'hours'),
        },
        ''
      ),
      DOM.div({ key: this.state.daypart, className: 'date-time-picker-count' }, this.state.daypart),
      DOM.span(
        {
          key: 'do',
          className: 'date-time-picker-btn fa fa-chevron-down',
          onClick: this.onStartClicking('toggleDayPart', 'hours'),
        },
        ''
      ),
    ]);
  }

  updateMilli (e) {
    let milli = parseInt(e.target.value, 10);
    if (milli === e.target.value && milli >= 0 && milli < 1000) {
      this.props.setTime('milliseconds', milli);
      this.setState({ milliseconds: milli });
    }
  }

  isFunction = functionToCheck => {
    let getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
  };

  renderHeader () {
    const { dateFormat } = this.props;
    if (!dateFormat) return null;

    let date = this.props.selectedDate || this.props.viewDate;
    let dateFormatted = this.isFunction(dateFormat) ? dateFormat(date) : date.format(dateFormat);
    return DOM.thead(
      { key: 'h' },
      DOM.tr(
        {},
        DOM.th(
          {
            className: 'date-time-picker-switch',
            colSpan: 4,
            onClick: this.props.showView('days'),
          },
          dateFormatted
        )
      )
    );
  }

  onStartClicking (action, type) {
    let me = this;

    return function () {
      let update = {};
      update[ type ] = me[ action ](type);
      me.setState(update);

      me.timer = setTimeout(function () {
        me.increaseTimer = setInterval(function () {
          update[ type ] = me[ action ](type);
          me.setState(update);
        }, 70);
      }, 500);

      me.mouseUpListener = function () {
        clearTimeout(me.timer);
        clearInterval(me.increaseTimer);
        me.props.setTime(type, me.state[ type ]);
        document.body.removeEventListener('mouseup', me.mouseUpListener);
      };

      document.body.addEventListener('mouseup', me.mouseUpListener);
    };
  }

  toggleDayPart (type) {
    // type is always 'hours'
    let value = parseInt(this.state[ type ], 10) + 12;
    if (value > this.timeConstraints[ type ].max) {
      value = this.timeConstraints[ type ].min + (value - (this.timeConstraints[ type ].max + 1));
    }
    return this.pad(type, value);
  }

  increase (type) {
    let value = parseInt(this.state[ type ], 10) + this.timeConstraints[ type ].step;
    if (value > this.timeConstraints[ type ].max) {
      value = this.timeConstraints[ type ].min + (value - (this.timeConstraints[ type ].max + 1));
    }

    return this.pad(type, value);
  }

  decrease (type) {
    let value = parseInt(this.state[ type ], 10) - this.timeConstraints[ type ].step;
    if (value < this.timeConstraints[ type ].min) {
      value = this.timeConstraints[ type ].max + 1 - (this.timeConstraints[ type ].min - value);
    }
    return this.pad(type, value);
  }

  pad (type, value) {
    let str = value + '';
    while (str.length < this.padValues[ type ]) str = '0' + str;
    return str;
  }

  handleClickOutside () {
    this.props.handleClickOutside();
  }

  render () {
    let me = this;
    let counters = [];

    this.state.counters.forEach(function (c) {
      if (counters.length) {
        counters.push(
          DOM.div(
            { key: 'sep' + counters.length, className: 'date-time-picker-counter-separator' },
            ':'
          )
        );
      }
      counters.push(me.renderCounter(c));
    });

    if (this.state.daypart !== false) {
      counters.push(me.renderDayPart());
    }

    if (this.state.counters.length === 3 && this.props.timeFormat.indexOf('S') !== -1) {
      counters.push(DOM.div({ className: 'date-time-picker-counter-separator', key: 'sep5' }, ':'));
      counters.push(
        DOM.div(
          { className: 'date-time-picker-counter date-time-picker-milli', key: 'm' },
          DOM.input({
            value: this.state.milliseconds,
            type: 'text',
            onChange: this.updateMilli,
          })
        )
      );
    }

    return DOM.div(
      { className: 'date-time-picker-time' },
      DOM.table({}, [
        this.renderHeader(),
        DOM.tbody(
          { key: 'b' },
          DOM.tr(
            {},
            DOM.td({}, DOM.div({ className: 'date-time-picker-counter-separator' }, counters))
          )
        ),
      ])
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/date-time-picker/TimeView.js